module.exports = new __parcel__URL__("service-success.e99f1cd7.svg").toString();